<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>لیست سفارشات</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.basket_id) }}</td>
                                    <td class="text-xs-center">{{ orderStatuses[props.item.order_status] }}</td>
                                    <td class="text-xs-center">{{ moneyFormat(props.item.total) }}</td>
                                    <td class="text-xs-center">{{ moneyFormat(props.item.offers_amount) }}</td>
                                    <td class="text-xs-center">{{ moneyFormat(props.item.transportation_cost) }}</td>
                                    <td class="text-xs-center">{{ deliveryGateways(props.item.delivery_type) }}</td>
                                    <td class="text-xs-center" style="direction: ltr">{{ toJalali(props.item.created_at) }}</td>
                                    <td class="text-xs-center">

                                        <v-tooltip top>
                                        <v-btn slot="activator" depressed outline icon fab dark color="primary" @click="$router.push(`/pages/order/show/`+props.item.ID)" small>
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                        <span>مشاهده‌ی جزییات</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                        <v-btn v-if="props.item.order_status === 0" slot="activator" depressed outline icon fab dark color="pink" small>
                                            <v-icon>cancel</v-icon>
                                        </v-btn>
                                            <span>لغو سفارش</span>
                                        </v-tooltip>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      orderStatuses: [
        'ثبت شده',
        'در حال انجام',
        'درحال ارسال',
        'ارسال شده',
        'برگشت خورده',
        'لغو شده',
      ],
      deliveryGatewaysData: [],
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شماره خرید',
            value: 'basket_id',
            align: 'center'
          },
          {
            text: 'وضعیت سفارش',
            value: 'order_status',
            align: 'center'
          },
          {
            text: 'مبلغ کل(﷼)',
            value: 'total',
            align: 'center'
          },
          {
            text: 'جمع تخفیفات(﷼)',
            value: 'offers_amount',
            align: 'center'
          },
          {
            text: 'هزینه حمل(﷼)',
            value: 'transportation_cost',
            align: 'center'
          },
          {
            text: 'نوع حمل',
            value: 'delivery_type',
            align: 'center'
          },
          {
            text: 'تاریخ سفارش',
            value: 'created_at',
            align: 'center'
          },
          {
            text: 'مدیریت',
            value: '',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  created: function () {
    this.axios.get('/reseller/baskets/')
      .then(response => {
        this.complex.items = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    this.axios.get('/reseller/delivery_gateways/')
      .then(response => {
        this.deliveryGatewaysData = response.data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    deliveryGateways: function (id) {
      let i = this.deliveryGatewaysData.findIndex(dg => dg.d_id === id);
      if (i < 0) {
        return 'نامشخص';
      }
      return this.deliveryGatewaysData[i].title;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/order/history.vue